import { kebabCase } from 'lodash';

export function getCancelReasonLabelKey(reason: string): string {
    return `post-sale.details.cancel-reason-${kebabCase(reason)}`;
}
